module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAKCAYAAABrGwT5AAAAAXNSR0IArs4c6QAAAI1JREFUKFOlksEJAkEMRfO7yK9Fb67etwpBj9qAy2IR9uH2IFiB9xEGpoDAQJABlT3OsDnnJf//BFJZJO/uPsQYHz8ElayQ7AHcAKxCCK/CVcOlWVUPAM4553VK6d0ElwEkryKyNbMOJMda6X+vwF5Ensvg1q1f2Tsz2zR5VtUjgFNzYItORXJy98v8ST6fwjaZ2KK35AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/arrowhead.png
// module id = ZCgx
// module chunks = 44